import { Auth } from 'aws-amplify'
import type { AuthPort } from '@/domain/auth/AuthPort'
import { getBearerToken } from '@/utils/authToken'
import { signOutCognito } from '@/utils/cognitoPoolConfig'

Auth.configure({
  authenticationFlowType: 'USER_PASSWORD_AUTH',
})

export class AmplifyAuthAdapter implements AuthPort {
  async signIn(email: string, password: string): Promise<void> {
    await Auth.signIn(email, password)
  }

  // why: delega en el resolvedor unificado (auth0 + cognito). Leer solo `Auth.currentSession()`
  // devolvia null para usuarios Auth0 (SSO), y HttpClient omitia el header -> 401 "credenciales
  // no se proveyeron" en los unicos modulos que usan este adapter (lotes bancarios). Simetrik,
  // 2026-08-25.
  async getBearerToken(): Promise<string | null> {
    try {
      return await getBearerToken()
    } catch {
      return null
    }
  }

  async signOut(): Promise<void> {
    await signOutCognito()
  }
}
